import React, { ReactNode } from "react";
import { MenuItem, Select } from "@mui/material";

interface IFormSelectItem {
    id?: string;
    value: string;
    title: ReactNode;
}

interface IFormSelectProps {
    disabled?: boolean;
    value: string;
    tooltip: string;
    items: IFormSelectItem[];
    onChange: (value: string) => void;
}

export const FormSelect = (props: IFormSelectProps) => {
    const handleChange = (event) => {
        const target = event.target;
        const value: string = target.value;
        props.onChange(value);
    };

    return (
        <Select title={props.tooltip} value={props.value} disabled={props.disabled} onChange={handleChange}>
            {props.items.map((item) =>
                <MenuItem key={item.id ?? item.value} value={item.value}>{item.title}</MenuItem>
            )}
        </Select>
    );
};